export default __webpack_public_path__ + "static/media/L_Forms.a2ad87bb.png";